import { useQuery } from '@tanstack/react-query';

import { queries } from '../api/queryKeys/queries';

export const useUnmatchedVesselProducts = (vesselId?: string) => {
    return useQuery({
        ...queries.vessels.detail(vesselId || '')._ctx.unmatchedProducts,
        enabled: !!vesselId,
    });
};
